export const CHECKOUT = {
  PRICE: 50000,
  VAT: 0,
  DISCOUNT: 0,
  ONE_YEAR: 12,
  QUANTITY: '12',
  TOTAL: 0,
};
